<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <h1 class="pt-3 mb-3">Schedules</h1>
  <p>
    Set the hours you'd like to use for your business.
    For example, you may have business hours from 9-5 each day, or you can configure separate hours
    for Lunch and Dinner. Assign these schedules to your Public Waitlist pages
    and to your Services (if enabled) to set their availability.
  </p>
  <form *ngIf="restaurantHoursForm" [formGroup]="restaurantHoursForm">
    <div class="table-responsive schedules-table">
      <table class="table table-striped table-bottom-spacer">
        <thead *ngIf="schedules">
        <th>#</th>
        <th></th>
        <th>Name</th>
        <th></th>
        <th></th>
        <th>Actions</th>
        </thead>
        <ng-container formArrayName="schedules">
          <tbody *ngFor="let schedule of schedulesArray.controls; index as schIndex;">
          <ng-container [formGroupName]="schIndex">
            <tr>
              <td>{{ schIndex + 1 }}</td>
              <td>
                <button *ngIf="schedule.get('exceptions').value.length"
                        (click)="showHideExceptions(schIndex)"
                        class="btn btn-info"
                        title="open exceptions">
                  <i class="bi"
                     [ngClass]="{'bi-chevron-down': showExceptions[schIndex+1], 'bi-chevron-right': !showExceptions[schIndex+1]}">
                  </i>
                </button>
              </td>
              <td>
                <span class="lead">{{ schedules[schIndex].name }}</span>
              </td>
              <td>
                <div [ngClass]="{'invisible':!showCalendar[schIndex+1]}" class="table-p-1">
                  <input type="text"
                         class="form-control"
                         name="extraDate"
                         placeholder="Date"
                         formControlName="extraDate"
                         [minDate]="dateOptions.minDate"
                         [firstDayOfWeek]="7"
                         ngbDatepicker
                         container="body"
                         #startDateDatepicker="ngbDatepicker"
                         (click)="startDateDatepicker.toggle()"/>
                </div>
              </td>
              <td>
                <button *ngIf="this.schedule.get('extraDate').value && showCalendar[schIndex+1]"
                        name="exceptions"
                        (click)="editHours(schIndex+1, schedules[schIndex], schedule.get('extraDate').value)"
                        class="btn btn-icon btn-info">
                  Edit detailed hours
                </button>
                <button *ngIf="!showCalendar[schIndex+1]"
                        (click)="showCalendar[schIndex+1] = true"
                        class="btn btn-info detail-btn">
                  Set Detailed Hours By Date
                </button>
              </td>
              <td>
                <div class="d-flex">
                  <button class="btn btn-icon btn-info mr-2"
                          (click)="addEditSchedule(schedules[schIndex])"
                          angularticsCategory="settings"
                          angulartics2On="click"
                          angularticsAction="Edit Schedule">
                    <tr-icon [icon]="icon.edit" [white]="true"></tr-icon>
                  </button>
                  <button *ngIf="!schedule.get('default').value"
                          class="btn btn-danger"
                          (click)="deleteSchedule(schedules[schIndex])"
                          angularticsCategory="settings"
                          angulartics2On="click"
                          angularticsAction="Delete Schedule">
                    <tr-icon [icon]="icon.delete" [white]="true"  classes="icon-secondary"></tr-icon>
                  </button>
                </div>
              </td>
            </tr>
            <ng-container *ngIf="schedule.get('exceptions').value.length">
              <ng-container formArrayName="exceptions">
                <tr *ngFor="let exception of exceptionsArray(schIndex).controls; index as excIndex"
                    [ngClass]="{'hide-exceptions': !showExceptions[schIndex+1]}">
                  <ng-container [formGroupName]="excIndex">
                    <td></td>
                    <td></td>
                    <td class="p-2 pt-3" valign="top">
                      {{ exception.get('date').value }}
                      <div *ngIf="exception.getError('conflictInsideDefaultException')" class="error-messages">The exceptions in the secondary schedules will not fit the updated exception hours. You should update the exceptions in the secondary schedule first before make changing in current exception.</div>
                      <div *ngIf="exception.getError('conflictInsideAdditionalException')" class="error-messages">Exception must fit to business hours exception or business schedule.</div>
                    </td>
                    <td class="p-2 text-center" valign="top">
                      <div class="d-flex justify-content-center" *ngIf="!exception.get('closed').value">
                        <div class="m-1">
                          <tr-timepicker-input name="firstExceptionDate" formControlName="hoursFirstValueFirstArray"></tr-timepicker-input>
                          <div *ngIf="exception.getError('hours')" class="error-messages">Close time must be after open time.</div>
                          <div *ngIf="exception.getError('nextDay')" class="error-messages">Close time must be before open time.</div>
                          <div *ngIf="exception.getError('overlap')" class="error-messages">Open hours must not overlap with other schedules.</div>
                          <div *ngIf="exception.getError('validTime')" class="error-messages">Not a valid time.</div>
                        </div>
                        <div class="m-1">
                          <tr-timepicker-input name="secondExceptionDate" formControlName="hoursSecondValueFirstArray"></tr-timepicker-input>
                          <div *ngIf="exception.getError('hours')" class="error-messages">Close time must be after open time.</div>
                          <div *ngIf="exception.getError('nextDay')" class="error-messages">Close time must be before open time.</div>
                          <div *ngIf="exception.getError('overlap')" class="error-messages">Open hours must not overlap with other schedules.</div>
                          <div *ngIf="exception.getError('validTime')" class="error-messages">Not a valid time.</div>
                        </div>
                      </div>
                    </td>
                    <td class="p-2 pt-3" valign="top">
                      <div class="d-flex">
                        <div class="form-check p-1" *ngIf="!exception.get('closed').value">
                          <label class="form-check-label mx-2 text-nowrap">
                            <input type="checkbox"
                                   class="form-check-input"
                                   formControlName="nextDay"
                                   name="nextDay">
                            Next day
                          </label>
                        </div>
                        <div class="form-check p-1" *ngIf="!exception.get('closed').value">
                          <label class="form-check-label mx-2 text-nowrap">
                            <input type="checkbox"
                                   class="form-check-input"
                                   formControlName="publicDisabled"
                                   name="publicDisabled">
                            <span [ngbTooltip]="'The business is open but disable public check-ins and bookings'">
                              Disable public
                            </span>
                          </label>
                        </div>
                        <div class="form-check p-1">
                          <label class="form-check-label mx-2" [class.disabled]="isDefaultScheduleException(schIndex, excIndex)">
                            <input type="checkbox"
                                   class="form-check-input"
                                   formControlName="closed"
                                   name="exceptions-closed">
                            Closed
                          </label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex">
                        <div *ngIf="isDefaultScheduleException(schIndex, excIndex)">This exception based on default schedule exception</div>
                        <button class="btn btn-info"
                                [class.invisible]="exception.pristine || (!exception.valid || (!exception.get('hoursFirstValueFirstArray').value || !exception.get('hoursSecondValueFirstArray').value) || isDefaultScheduleException(schIndex, excIndex)) && !exception.get('closed').value && !exception.get('publicDisabled').value"
                                (click)="updateSchedule(schedules[schIndex], schedule.get('exceptions'), excIndex)"
                                angularticsCategory="settings"
                                angulartics2On="click"
                                angularticsAction="Save New Hours"
                                title="Save">
                          <i class="bi bi-save-fill icon-secondary"></i>
                        </button>
                        <button type="button"
                                [class.invisible]="isDefaultScheduleException(schIndex, excIndex)"
                                class="btn btn-danger ml-2"
                                title="Remove"
                                (click)="removeExtraDay(schIndex, schedules[schIndex], excIndex)">
                          <tr-icon [icon]="icon.delete" [white]="true" ></tr-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          </tbody>
        </ng-container>
      </table>
    </div>
    <div class="add-new">
      <div class="add-new-blocker" slot="fixed">
        <button type="button"
                class="btn btn-accent btn-circle"
                (click)="addEditSchedule()"
                id="addEditSchedule-button">
          <tr-icon [icon]="icon.plus" [size]="size.extraLarge" [color]="color.white"></tr-icon>
        </button>
      </div>
    </div>
  </form>

</section>
